<template>
    <Layout
        :header="{ text: '保單借款', backBtn: { visible: true }, closeBtn: { visible: true, to: { name: routeName.CLOUD_E_COUNTER_HOME } }, }">
        <div class="pt-2 pb-6">
            <Process :steps="['同意條款', '選擇保單', '確認資料', '手機驗證',]" :index="2"></Process>
        </div>
        <div class="pb-4 flex justify-between items-center">
            <h2 class="font-bold text-2xl">確認以下已填寫資料</h2>
            <div class=" text-[#0093C1] textsm">
                <router-link :to="router.options.history.state.back" replace>
                    <svg class="inline-block" fill="#0093C1" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                        viewBox="0 0 24 24">
                        <title>square-edit-outline</title>
                        <path
                            d="M5,3C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V12H19V19H5V5H12V3H5M17.78,4C17.61,4 17.43,4.07 17.3,4.2L16.08,5.41L18.58,7.91L19.8,6.7C20.06,6.44 20.06,6 19.8,5.75L18.25,4.2C18.12,4.07 17.95,4 17.78,4M15.37,6.12L8,13.5V16H10.5L17.87,8.62L15.37,6.12Z" />
                    </svg>修改
                </router-link>
            </div>
        </div>
        <div class="pb-4">
            <h3 class="font-bold text-xl pb-4">匯款帳號</h3>
            <CaseBox :caseBox="bankAccount"></CaseBox>
        </div>
        <div class="pb-4">
            <h3 class="font-bold text-xl pb-4">借款明細</h3>
            <CaseBox>
                <div class="flex justify-between items-center">
                    <div class="text-md">共欲借款{{ currencyText }}</div>
                    <div class="font-bold text-xl"> ${{ totalAmount }}</div>
                </div>
                <!--
                    <div class="text-right">
                        優惠方案申請金額 <span class="text-[#00A59B]">$34,000</span>
                    </div>
                -->
            </CaseBox>
        </div>
        <div class="pb-4">
            <CaseBox :caseBox="policy" v-for="policy in policyList" />
        </div>
        <!--
            <div class="pb-4">
                <h3 class="font-bold text-xl pb-2">相關證明文件</h3>
                <p class="text-sm">透過「My data 平台」提供「低收、中低收入戶」證明文件</p>
                <CaseBox>
                    <ul class="text-md">
                        <li class="py-4 border-b first:pt-0 last:pb-0 last:border-b-0" v-for="item in ['我的證明文件.jpg', '我的證明文件.pdf']">
                            {{ item }}
                        </li>
                    </ul>
                </CaseBox>
            </div>
        -->
        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                @click="goNextPage">下一步</button>
        </template>
        <Loading :is-loading="isLoading" />
    </Layout>
</template>
<script setup>
import '@/assets/cloudCounter/css/style.css'
import { ref } from 'vue';

import Layout from '@/components/cloudCounter/Layout.vue'
import Process from '@/components/cloudCounter/Process.vue'
import CaseBox from '@/components/cloudCounter/CaseBox.vue'
import { useRouter } from 'vue-router';
import { getResult } from '@/apis/CloudECounter';
import Loading from '@/components/Loading.vue';
import { openPopupCatchMessage } from '@/utils/vfmUtils';
import routeName from '@/router/constant';

const router = useRouter();
const isLoading = ref(false);
const bankAccount = ref({});
const policyList = ref([]);
const totalAmount = ref('');
const currencyText = ref('');
const notMeeting = ref(false);

const goNextPage = () => {
    if (notMeeting.value) {
        router.push({ name: routeName.CLOUD_E_COUNTER_LOAN_CONTACT_INFO_CHECK });
    } else {
        router.push({ name: routeName.CLOUD_E_COUNTER_LOAN_RESERVE_PHONE });
    }
}

const initData = async () => {
    isLoading.value = true;
    try {
        const res = await getResult();
        const bankNo = res.data?.pon4300?.after?.bank?.bankNo;
        const bankName = res.data?.pon4300?.after?.bank?.bankName;
        const account = res.data?.pon4300?.after?.bank?.bankAccount;
        bankAccount.value = { key: '銀行帳號', value: `${bankNo} ${bankName}<br>${account}` }
        policyList.value = res.data?.pon4300?.after?.pon4300ResultDataList?.map(policy => {
            return {
                boxList: [
                    {
                        title: `${policy.item} ${policy.itemName}`,
                        subTitle: policy.fullPolicyNo,
                        iconTitle: '', //待補 policy.isSpecial ? '申請優惠利率方案':''
                        list: [
                            { key: '本月利率（年利率）', value: `${policy.loanRate}%`, },
                            { key: '借款幣別', value: res.data?.pon4300?.after?.currencyText, },
                            { key: '借款金額', value: `$${thousandthsFormat(policy.amount)}`, },
                        ],
                    },
                ],
            }
        });
        totalAmount.value = thousandthsFormat(res.data?.pon4300?.after?.totalAmount);
        currencyText.value = res.data?.pon4300?.after?.currencyText;
        notMeeting.value = res.data?.pon4300?.notMeeting;
    } catch (ex) {
        openPopupCatchMessage(ex);
    } finally {
        isLoading.value = false;
    }
}
initData();

const thousandthsFormat = (value) => {
    const regex = /\B(?=(\d{3})+(?!\d))/g
    value = value.toString()
    return value.replace(regex, ',')
}

</script>
<style scoped></style>
